export class BackorderLine {
  id: number
  productId: number
  expectedDeliveryDate: string | null
  quantity: string
  saleDate: string
  saleReference: string
  customerOrderNumber: string | null
  erpOrderNumber: string | null

  constructor(
    id: number,
    expectedDeliveryDate: string | null,
    productId: number,
    quantity: string,
    saleDate: string,
    saleReference: string,
    customerOrderNumber: string | null,
    erpOrderNumber: string | null,
  ) {
    this.expectedDeliveryDate = expectedDeliveryDate
    this.id = id
    this.productId = productId
    this.quantity = quantity
    this.saleDate = saleDate
    this.saleReference = saleReference
    this.customerOrderNumber = customerOrderNumber
    this.erpOrderNumber = erpOrderNumber
  }
}

export class BackOrderProductResponse {
  lines: BackorderLine[]
  totalBackorderCount: number

  constructor(lines: BackorderLine[], totalBackorderCount: number) {
    this.lines = lines
    this.totalBackorderCount = totalBackorderCount
  }
}

export class Basket {
  constructor(
    public basketId: string,
    public name: string | NoNameGiven,
    public lineCount: number,
    public cumulatedCount: number,
    public deliveryPolicy: DeliveryPolicy,
  ) {}
}

export class BasketUser {
  first_name: string
  middle_name: string
  last_name: string
  email: string

  constructor(first_name: string, middle_name: string, last_name: string, email: string) {
    this.first_name = first_name
    this.middle_name = middle_name
    this.last_name = last_name
    this.email = email
  }
}

export class BasketParty {
  party_id: number
  name: string

  constructor(party_id: number, name: string) {
    this.party_id = party_id
    this.name = name
  }
}

export class BasketItem {
  basketId: string
  name: string | NoNameGiven
  deliveryPolicy: DeliveryPolicy
  user: BasketUser
  party: BasketParty

  constructor(basketId: string, name: string | NoNameGiven, deliveryPolicy: DeliveryPolicy, user: BasketUser, party: BasketParty) {
    this.basketId = basketId
    this.name = name
    this.deliveryPolicy = deliveryPolicy
    this.user = user
    this.party = party
  }
}

export class BasketList {
  constructor(
    public baskets: Basket[],
    public selectedBasket: Basket | NoBasketSelected,
  ) {}
}

export class BasketOverview {
  baskets: BasketItem[]

  constructor(baskets: BasketItem[]) {
    this.baskets = baskets
  }
}

export class BasketNameTooLong {
  maxLength: number
  suppliedLength: number

  constructor(maxLength: number, suppliedLength: number) {
    this.maxLength = maxLength
    this.suppliedLength = suppliedLength
  }
}

export type BasketSelection = NoBasketSelected | string

export class ConfiguredDeliveryPolicy {
  id: number
  name: string

  constructor(id: number, name: string) {
    this.id = id
    this.name = name
  }
}

export class CreateAdditionalBasketFailure {
  reason: BasketNameTooLong
  success: boolean = false

  constructor(reason: BasketNameTooLong) {
    this.reason = reason
  }
}

export class CreateAdditionalBasketResponse {
  basketId: string
  success: boolean = true

  constructor(basketId: string) {
    this.basketId = basketId
  }
}

export type CreateAdditionalBasketUnionResponse = CreateAdditionalBasketResponse | CreateAdditionalBasketFailure

export type DeliveryPolicy = ConfiguredDeliveryPolicy | TrivialDeliveryPolicy

export class GetDeliveryPoliciesResponse {
  deliveryPolicies: DeliveryPolicy[]
  default: DeliveryPolicy = new TrivialDeliveryPolicy()

  constructor(
    deliveryPolicies: DeliveryPolicy[],
    default_: DeliveryPolicy,
  ) {
    this.deliveryPolicies = deliveryPolicies
    this.default = default_
  }
}

export class GetSelectedBasketResponse {
  basketSelection: BasketSelection

  constructor(basketSelection: BasketSelection) {
    this.basketSelection = basketSelection
  }
}

export class NameBasketFailure {
  failureReason: BasketNameTooLong
  success: boolean = false

  constructor(reason: BasketNameTooLong) {
    this.failureReason = reason
  }
}

export class NameBasketResponse {
  success: boolean = true
}

export type NameBasketUnionResponse = NameBasketResponse | NameBasketFailure

export class NoBasketSelected {}

export class NoNameGiven {}

export class PossibleTransferBasketRecipients {
  '@type': 'PossibleTransferBasketRecipients'
  recipients: TransferBasketRecipient[]

  constructor(recipients: TransferBasketRecipient[]) {
    this.recipients = recipients
  }
}

export class TransferBasketRecipient {
  userId: number
  name: string
  emailAddress: string

  constructor(userId: number, name: string, emailAddress: string) {
    this.userId = userId
    this.name = name
    this.emailAddress = emailAddress
  }
}

export class TrivialDeliveryPolicy {
  name = 'Regulier'
}


export type BasketContact = {
  name: string
  telephone: string
}

export class BasketHasNoContact {}
